type stateType = { shopId: number; b2bShopId: number; b2bToken: string }

export const state = () => ({
  shopId: 0,
  b2bShopId: 0,
  b2bToken: '',
})

export const mutations = {
  setShopId(state: stateType, shopId: number) {
    state.shopId = shopId
  },
  setB2bShopId(state: stateType, shopId: number) {
    state.b2bShopId = shopId
  },
  setB2bToken(state: stateType, token: string) {
    state.b2bToken = token
  },
}

export const getters = {
  isActive(state: stateType) {
    if (state.shopId !== 0) {
      return true
    }
    return false
  },
  getShopId(state: stateType) {
    return state.shopId
  },
  getB2bShopId(state: stateType) {
    return state.b2bShopId
  },
  getB2bToken(state: stateType) {
    return state.b2bToken
  },
}

export const actions = {
  checkLocalStorage({ commit }: { commit: any }) {
    if (process.client) {
      const shopLoginData = localStorage.getItem('shoplogin')

      if (shopLoginData) {
        const { shopid, b2bshopid, b2btoken, timestamp } =
          JSON.parse(shopLoginData)
        const currentTime = Math.floor(Date.now() / 1000)

        if (currentTime - timestamp <= 24 * 60 * 60) {
          commit('setShopId', Number(shopid))
          commit('setB2bShopId', Number(b2bshopid))
          commit('setB2bToken', b2btoken)
        }
      }
    }
  },
}
